import { Component, h, Host, Prop } from '@stencil/core';
import { type BannerItem } from '../../../types/blog';

@Component({
  tag: 'sy-blog-banner-list',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class SyBlogBannerList {
  /**
   * Banner body
   */
  @Prop() bannerItems: BannerItem[];

  render() {
    return (
      <Host>
        {(this.bannerItems || []).map((item, index) => (
          <sy-blog-banner-item
            key={index}
            identifier={item.identifier}
            backgroundType={item.backgroundType}
            backgroundColor={item.backgroundColor}
            desktopBackgroundImage={item.desktopBackgroundImage}
            mobileBackgroundImage={item.mobileBackgroundImage}
            showImageOnRightSide={item.showImageOnRightSide}
            desktopImage={item.desktopImage}
            mobileImage={item.mobileImage}
            htmlContent={item.htmlContent}
            ctaIcon={item.ctaIcon}
            ctaLabel={item.ctaLabel}
            ctaHref={item.ctaHref}
            buttonTarget={item.buttonTarget}
          />
        ))}
      </Host>
    );
  }
}
